<template>
  <div class="per-mob-detail">
    <img class="top-banner" src="@/assets/img/banner.png" alt="" />
    <div class="content-box">
      <div class="info-top">
        <div class="info-title">经纪人信息</div>
        <div class="info-big">
          <div class="info-big-left">
            <img :src="obj.userImg" alt="" />
          </div>
          <div class="info-big-right">
            <div class="info-tab">
              <div class="info-left">姓 名:</div>
              <div class="info-right">{{obj.name}}</div>
            </div>
            <div class="info-tab">
              <div class="info-left">性别:</div>
              <div class="info-right">{{obj.sex}}</div>
            </div>
            <div class="info-tab">
              <div class="info-left">籍贯:</div>
              <div class="info-right"></div>
            </div>

            <div class="info-tab">
              <div class="info-left">电话:</div>
              <div class="info-right">{{obj.phoneNo}}</div>
            </div>
            <div class="info-tab">
              <div class="info-left">从业编码:</div>
              <div class="info-right">{{obj.code}}</div>
            </div>
            <div class="info-tab">
              <div class="info-left">毕业院校:</div>
              <div class="info-right">{{obj.graduatedUniversity}}</div>
            </div>
            <div class="info-tab">
              <div class="info-left">所学专业:</div>
              <div class="info-right">{{obj.major}}</div>
            </div>
            <div class="info-tab">
              <div class="info-left">毕业时间:</div>
              <div class="info-right">{{obj.graduationDate}}</div>
            </div>
            <div class="info-tab">
              <div class="info-left">电子邮箱:</div>
              <div class="info-right">{{obj.email}}</div>
            </div>
          </div>
        </div>
      </div>

      <div class="part-title">所属经纪机构</div>
      <div class="tab-bottom">
        <div class="tab-lr">
          <div class="tab-lr-left">机构名称：</div>
          <div class="tab-lr-right">{{gsObj.name}}</div>
        </div>
        <div class="tab-lr">
          <div class="tab-lr-left">行政区：</div>
          <div class="tab-lr-right">{{gsObj.districtName}}</div>
        </div>
        <div class="tab-lr">
          <div class="tab-lr-left">注册资本：</div>
          <div class="tab-lr-right">{{gsObj.registeredCapital}}<span v-if="obj.registeredCapital">万元</span></div>
        </div>
        <div class="tab-lr">
          <div class="tab-lr-left">企业地址：</div>
          <div class="tab-lr-right">{{gsObj.address}}</div>
        </div>
        <div class="tab-lr">
          <div class="tab-lr-left">联系电话：</div>
          <div class="tab-lr-right">{{gsObj.contactsPhone}}</div>
        </div>
        <div class="tab-lr">
          <div class="tab-lr-left">详细：</div>
          <div class="tab-lr-right">{{gsObj.profile}}</div>
        </div>
      </div>

      <div class="part-title">人员证书</div>
      <div class="tab-bottom">
        <div class="tab-lr">
          <div class="tab-lr-left">证书名称：</div>
          <div class="tab-lr-right"></div>
        </div>
        <div class="tab-lr">
          <div class="tab-lr-left">证书编号：</div>
          <div class="tab-lr-right"></div>
        </div>
      </div>

      <div class="part-title">良好行为记录</div>

      <div class="tab-bottom" v-for="(item,index) in obj && obj.good || []" :key="index">
        <div class="tab-lr">
          <div class="tab-lr-left">获奖名称：</div>
          <div class="tab-lr-right">{{item.title}}</div>
        </div>
        <div class="tab-lr">
          <div class="tab-lr-left">获奖日期：</div>
          <div class="tab-lr-right">{{item.recordDate}}</div>
        </div>
        <div class="tab-lr">
          <div class="tab-lr-left">积分分值：</div>
          <div class="tab-lr-right">{{item.points}}</div>
        </div>
      </div>

      <div class="part-title">不良行为记录</div>
        <div class="tab-bottom"  v-for="(item,index) in obj && obj.bad || []" :key="index">
        <div class="tab-lr">
          <div class="tab-lr-left">违规名称：</div>
          <div class="tab-lr-right">{{item.title}}</div>
        </div>
        <div class="tab-lr">
          <div class="tab-lr-left">违规日期：</div>
          <div class="tab-lr-right">{{item.recordDate}}</div>
        </div>
        <div class="tab-lr">
          <div class="tab-lr-left">扣分分值：</div>
          <div class="tab-lr-right">{{item.points}}</div>
        </div>
      </div>

      <div class="part-title">机构人员积分</div>

      <!-- <div class="tab-bottom">
        <div class="tab-lr">
          <div class="tab-lr-left">开始日期：</div>
          <div class="tab-lr-right"></div>
        </div>
        <div class="tab-lr">
          <div class="tab-lr-left">结束日期：</div>
          <div class="tab-lr-right"></div>
        </div>
        <div class="tab-lr">
          <div class="tab-lr-left">上次积分初始日期：</div>
          <div class="tab-lr-right"></div>
        </div>
        <div class="tab-lr">
          <div class="tab-lr-left">总分：</div>
          <div class="tab-lr-right"></div>
        </div>

        <div class="tab-lr">
          <div class="tab-lr-left">信用等级：</div>
          <div class="tab-lr-right">风险</div>
        </div>
      </div> -->
    </div>

    <div class="footer">
      <p>主办单位: 山东省聊城市东昌府区</p>
      <p>创建时间:2021-11-11</p>
      <p>技术支持单位: 山东聊城</p>
    </div>
  </div>
</template>

<script>
import "@/assets/util/rem.js";
import { personDetail, personBehavior } from "@/assets/api/person";
import { companyDetail } from "@/assets/api/company";

export default {
  name: "mob-detail",
  components: {},

  data() {
    return {
      id: this.$route.query.id,
      obj: '',
      gsObj: {},
      goodList: [],
      badList: [],
    };
  },
  mounted() {
    this.getDetail();
    // this.getBehaviorGood();
    // this.getBehaviorBad();
  },
  methods: {
     async getDetail() {
      const res = await personDetail({ id: this.id });
      if (res && res.data && res.data.code == 200) {
        this.obj = res.data.data
        this.obj.userImg = `${this.$globalData.imgFile}${this.obj.photo}`
        if (this.obj.companyId) {
          this.getCompany()
        }
      }
    },
    async getCompany() {
      const res = await companyDetail({ id: this.obj.companyId });
      if (res && res.data && res.data.code == 200) {
        this.gsObj = res.data.data
      }
    },
    async getBehaviorGood() {
      const res = await personBehavior({
        id: this.id,
        good: 1,
      });
      if (res && res.data && res.data.code == 200) {
        this.goodList = res.data.rows || [];
      }
    },
    async getBehaviorBad() {
      const res = await personBehavior({
        id: this.id,
        good: 0,
      });
      if (res && res.data && res.data.code == 200) {
        this.badList = res.data.rows || [];
      }
    },

  },
  computed: {},
};
</script>

<style lang="less">
.per-mob-detail {
  width: 7.5rem;
  margin: 0 auto;
  background: rgb(255, 153, 0);
  min-height: 100vh;
  overflow: hidden;
  .top-banner {
    width: 100%;
    height: auto;
  }
  .content-box {
    width: 6.3rem;
    padding: 0.2rem;
    background: #fff;
    margin: 0.6rem auto 0;
    .info-top {
      border: 1px solid #eee;
      padding: 0.2rem;
      .info-title {
        font-size: 0.42rem;
        color: #222;
        font-weight: bold;
        text-align: center;
      }
      .info-big {
        display: flex;
        justify-content: space-between;
        .info-big-left {
          width: 1.6rem;
          height: auto;
          flex-shrink: 0;
          margin-right: 0.2rem;
          img {
            width: 1.6rem;
            height: auto;
          }
        }
        .info-big-right {
          flex: 1;
        }
      }
      .info-desc {
        margin: 0.22rem 0;
        font-size: 0.28rem;
        color: #888;
      }
    }
    .info-tab {
      display: flex;
      margin-top: 0.12rem;
      align-items: flex-start;
      font-size: 0.28rem;
      color: #555;
      .info-left {
        flex-shrink: 0;
        width: 1.4rem;
        margin-right: 0.22rem;
        word-break: break-all;
        word-wrap: break-word;
      }
      .info-right {
        flex: 1;
        word-break: break-all;
        word-wrap: break-word;
      }
    }
    .part-title {
      font-size: 0.26rem;
      color: #444;
      margin: 0.64rem 0 0.24rem;
    }
    .tab-bottom {
      border-bottom: 1px solid #eee;
    }
    .tab-lr {
      border-bottom: 1px solid #eee;
      display: flex;
      font-size: 0.24rem;
      line-height: 1.6;

      .tab-lr-left {
        width: 1.5rem;
        flex-shrink: 0;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        padding: 0.24rem;
        padding-left: 0;
        min-height: 0.42rem;
        color: #999;
        word-wrap: break-word;
        word-break: break-all;
      }
      .tab-lr-right {
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        padding: 0.24rem;
        min-height: 0.84rem;
        background: #fff;
        color: #222;
        word-wrap: break-word;
        word-break: break-all;
      }
    }

    .tab-tb-top {
      border: 1px solid #eee;
      display: flex;
      font-size: 0.24rem;
      line-height: 1.6;
      & > div {
        border-right: 1px solid #eee;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 0.24rem;
        min-height: 0.42rem;
        background: #f5f5f5;
        color: #999;
        word-wrap: break-word;
        word-break: break-all;
        &:last-child {
          border-right: none;
        }
      }
    }
    .tab-tb-item {
      border: 1px solid #eee;
      border-top: none;
      display: flex;
      font-size: 0.24rem;
      line-height: 1.6;
      background: #fff;
      &:nth-of-type(2n) {
        background: #f5f5f5;
      }
      & > div {
        border-right: 1px solid #eee;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 0.24rem;
        min-height: 0.42rem;
        color: #333;
        word-wrap: break-word;
        word-break: break-all;
        &:last-child {
          border-right: none;
        }
      }
    }
  }
  .footer {
    width: 7rem;
    margin: 0 auto;
    color: #fff;
    padding: 0.42rem 0;
    p {
      text-align: center;
      font-size: 0.24rem;
      color: #eee;
      margin: 0.12rem 0;
    }
  }
  #mapBox {
    width: 100%;
    height: 3rem;
  }
}
</style>